import { useNavigate, useLocation } from "react-router-dom";
import { logout, isAdmin, getUser } from "../auth";

export default function Layout({ children, title, subtitle }) {
  const navigate   = useNavigate();
  const location   = useLocation();
  const admin      = isAdmin();
  const user       = getUser();

  const navItems = admin
    ? [{ label: "Home",        path: "/admin",           exact: true  },
       { label: "Delegates",   path: "/admin/delegates", exact: false },
       { label: "Nominations", path: "/admin/events",    exact: false },
       { label: "Jury Members",path: "/admin/jury",      exact: false }]
    : [{ label: "My Events",   path: "/jury/events",     exact: false }];

  const isActive = (item) =>
    item.exact
      ? location.pathname === item.path
      : location.pathname.startsWith(item.path);
  const initials = (user?.name || user?.firstName || "A")[0].toUpperCase();
  const displayName = user?.name || user?.firstName || "Admin";

  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)", fontFamily: "'Inter', sans-serif" }}>

      {/* ── Top Nav ── */}
      <nav style={{
        background: "var(--nav-bg)",
        height: 60,
        padding: "0 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "sticky",
        top: 0,
        zIndex: 200,
        boxShadow: "0 1px 0 rgba(255,255,255,0.05)",
      }}>

        {/* Left: Logo + Nav */}
        <div style={{ display: "flex", alignItems: "center", gap: 36 }}>

          {/* Logo */}
          <div
            onClick={() => navigate(admin ? "/admin" : "/jury/events")}
            style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", userSelect: "none" }}
          >
            <div style={{
              width: 34, height: 34, borderRadius: 9,
              background: "linear-gradient(135deg, #1D9AEC 0%, #0EA5E9 100%)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontWeight: 800, fontSize: 17, color: "#fff", letterSpacing: "-0.5px",
              boxShadow: "0 2px 8px rgba(29,154,236,0.4)",
            }}>V</div>
            <div>
              <span style={{ fontWeight: 700, fontSize: 15, color: "#fff", letterSpacing: "-0.02em" }}>VOH</span>
              <span style={{
                marginLeft: 6, fontSize: 11, fontWeight: 600, letterSpacing: "0.08em",
                color: "#1D9AEC", textTransform: "uppercase",
                background: "rgba(29,154,236,0.12)",
                padding: "2px 7px", borderRadius: 4,
              }}>
                {admin ? "Admin" : "Jury"}
              </span>
            </div>
          </div>

          {/* Nav Links */}
          <div style={{ display: "flex", gap: 2 }}>
            {navItems.map(item => {
              const active = isActive(item);
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  style={{
                    background: active ? "rgba(29,154,236,0.14)" : "transparent",
                    border: "none",
                    color: active ? "#60C3F5" : "#94A3B8",
                    padding: "7px 14px",
                    borderRadius: 7,
                    cursor: "pointer",
                    fontSize: 13.5,
                    fontWeight: active ? 600 : 500,
                    letterSpacing: active ? "-0.01em" : "normal",
                    transition: "all 0.15s",
                    position: "relative",
                  }}
                >
                  {item.label}
                  {active && (
                    <span style={{
                      position: "absolute", bottom: -1, left: "50%",
                      transform: "translateX(-50%)",
                      width: 20, height: 2,
                      background: "#1D9AEC",
                      borderRadius: 2,
                    }} />
                  )}
                </button>
              );
            })}
          </div>
        </div>

        {/* Right: User + Logout */}
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
            <div style={{
              width: 34, height: 34, borderRadius: "50%",
              background: "linear-gradient(135deg, #6366F1, #1D9AEC)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontWeight: 700, fontSize: 14, color: "#fff",
              boxShadow: "0 2px 6px rgba(99,102,241,0.4)",
              flexShrink: 0,
            }}>{initials}</div>
            <span style={{ fontSize: 13, color: "#CBD5E1", fontWeight: 500 }}>{displayName}</span>
          </div>

          <div style={{ width: 1, height: 20, background: "rgba(255,255,255,0.08)" }} />

          <button
            onClick={logout}
            style={{
              background: "transparent",
              border: "1px solid rgba(239,68,68,0.25)",
              color: "#F87171",
              padding: "6px 14px",
              borderRadius: 7,
              cursor: "pointer",
              fontSize: 13,
              fontWeight: 600,
              transition: "all 0.15s",
              letterSpacing: "-0.01em",
            }}
            onMouseEnter={e => { e.currentTarget.style.background = "rgba(239,68,68,0.1)"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
          >
            Sign Out
          </button>
        </div>
      </nav>

      {/* ── Page Body ── */}
      <div className="voh-page" style={{ maxWidth: 1200, margin: "0 auto", padding: "32px 24px" }}>
        {(title || subtitle) && (
          <div style={{ marginBottom: 28 }}>
            {title && (
              <h1 style={{
                fontSize: 22, fontWeight: 700, color: "var(--text-primary)",
                margin: 0, letterSpacing: "-0.03em",
              }}>{title}</h1>
            )}
            {subtitle && (
              <p style={{ fontSize: 13.5, color: "var(--text-muted)", margin: "5px 0 0" }}>{subtitle}</p>
            )}
          </div>
        )}
        <div className="fade-in">{children}</div>
      </div>
    </div>
  );
}
